import { Col, Container, Row } from "react-bootstrap";
import { Box, Button, Card, CardContent, Dialog, DialogContent, Grid, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";



function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function Publications() {
    const [publications, setPublication] = useState(null);
    const [value, setValue] = useState(0);
    const [openCertificate, setOpenCertificate] = useState(false);
    const [activeCertificate, setActiveCertificate] = useState(null);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleOpenCertificate = (cert) => {
        setActiveCertificate(cert);
        setOpenCertificate(true);
    };

    const handleCloseCertificate = () => {
        setOpenCertificate(false);
        setActiveCertificate(null);
    };

    const getData=()=>{
        fetch(process.env.PUBLIC_URL+'/data/publications.json'
        ,{
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        }
        )
          .then(function(response){
            console.log(response)
            return response.json();
          })
          .then(function(myJson) {
            console.log(myJson);
            setPublication(myJson);
          });
      }
      useEffect(()=>{
        getData();
      },[])

    // these constants holds the specific type of publications
    const journals = publications!==null? publications.filter(p =>
        p.type === 'journal'
    ):" ";
    
    const conferences = publications!==null?publications.filter(p =>
        p.type === 'conference'
    ):" ";

    const patents = publications!==null?publications.filter(p =>
        p.type === 'patent'
    ):" ";

    const techTransfers = publications!==null?publications.filter(p =>
        p.type === 'techtransfer'
    ):" ";
    
    const books = publications!==null?publications.filter(p =>
        p.type === 'book'
    ):" ";

    const chapters = publications!==null?publications.filter(p =>
        p.type === 'chapter'
    ):" ";

    const patentCertificates = [
        {
            src: process.env.PUBLIC_URL + "/data/images/publication/patent4.jpg",
            alt: "Patent certificate 4",
            pdfSrc: process.env.PUBLIC_URL + "/data/files/patents/VMC%20Patent%20Certificate%20352065.pdf"
        },
        {
            src: process.env.PUBLIC_URL + "/data/images/publication/patent3.jpg",
            alt: "Patent certificate 3",
            pdfSrc: process.env.PUBLIC_URL + "/data/files/patents/VMC%20Patent%20Certificate%20342247.pdf"
        },
        {
            src: process.env.PUBLIC_URL + "/data/images/publication/patent1.jpg",
            alt: "Patent certificate 1",
            pdfSrc: process.env.PUBLIC_URL + "/data/files/patents/VMC%20+%20Amruta%20Patent.pdf"
        },
        {
            src: process.env.PUBLIC_URL + "/data/images/publication/patent2.jpg",
            alt: "Patent certificate 2",
            pdfSrc: process.env.PUBLIC_URL + "/data/files/patents/VMC%20+%20KAPIL%20Patent%202024.pdf"
        }
    ];
    // this function formats the provided publication type for rendering
    const pub = (type) => type!==" "?type.map(p=>
        <Grid item size={{ xs: 12, sm: 6, md: 4}} style={{display: 'flex'}}>
            
        <Card variant="outlined" sx={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', flex:1}}>
            <CardContent>
                <Typography sx={{fontSize: 16, marginBottom:"10px"}} variant="h5" component="div">{p.title}</Typography>
                <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>{p.authors}</Typography>
                <Typography sx={{fontSize: 14, marginTop:"10px"}}>{p.publication}, {p.year}{p.status!=null?' ('+p.status+')':' '}</Typography>
            </CardContent>
        </Card> 
        </Grid>
    ): " ";

    return(
        <>
        <Container>
        <Box width="100%" sx={{position:"relative", marginTop:"100px"}}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', position:"fixed", marginTop:"-33px", backgroundColor:"#fff", left:0, width:"100%"}}>
                <Container>
                <Tabs value={value} 
                    onChange={handleChange} 
                    centered
                    variant="scrollable"
                    scrollButtons="auto">
                    <Tab label="Journals" />
                    <Tab label="Conferences" />
                    <Tab label="Patents" />
                    <Tab label="Tech Transfer" />
                    <Tab label="Books" />
                    <Tab label="Chapters" />
                </Tabs>
                </Container>
            </Box>

            <CustomTabPanel value={value} index={0}>
            <Grid container spacing={2}>
                {pub(journals)}
            </Grid>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
            <Grid container spacing={2}>
                {pub(conferences)}
            </Grid>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={2}>
            <Typography variant="h5" align="center" sx={{ marginBottom: "20px", fontWeight: 600 }}>Patent Certificates</Typography>
            <Box sx={{ marginBottom: "24px" }}>
                <Row className="g-3" style={{ alignItems: "stretch" }}>
                    {patentCertificates.map((cert) => (
                        <Col xs={12} sm={6} md={3} key={cert.alt}>
                            <Box
                                sx={{
                                    width: "100%",
                                    height: { xs: "280px", sm: "300px", md: "320px" },
                                    borderRadius: "12px",
                                    border: "1px solid #e6e6e6",
                                    backgroundColor: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "12px",
                                    position: "relative",
                                    overflow: "hidden",
                                    "&:hover .cert-overlay": { opacity: 1 }
                                }}
                            >
                                <Box
                                    component="img"
                                    src={cert.src}
                                    alt={cert.alt}
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain"
                                    }}
                                />
                                <Box
                                    className="cert-overlay"
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        backgroundColor: "rgba(0, 0, 0, 0.35)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        opacity: 0,
                                        transition: "opacity 0.2s ease"
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={() => handleOpenCertificate(cert)}
                                        sx={{ textTransform: "none" }}
                                    >
                                        Expand
                                    </Button>
                                </Box>
                            </Box>
                        </Col>
                    ))}
                </Row>
            </Box>
            <Dialog open={openCertificate} onClose={handleCloseCertificate} maxWidth="xl" fullWidth>
                <DialogContent sx={{ padding: { xs: "8px", sm: "16px" }, position: "relative" }}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button size="small" variant="outlined" onClick={handleCloseCertificate}>X</Button>
                    </Box>
                    {activeCertificate && (
                        <Box
                            component="iframe"
                            title={activeCertificate.alt}
                            src={activeCertificate.pdfSrc}
                            sx={{
                                width: "100%",
                                height: "85vh",
                                border: 0,
                                marginTop: "8px"
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
            <Grid container spacing={2}>
                {pub(patents)}
            </Grid>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={3}>
            <Grid container spacing={2}>
                {pub(techTransfers)}
            </Grid>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={4}>
            <Grid container spacing={2}>
                {pub(books)}
            </Grid>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={5}>
            <Grid container spacing={2}>
                {pub(chapters)}
            </Grid>
            </CustomTabPanel>
            
        </Box>
            <br/>
            <br/>
        </Container>
        </>
    )
};
